<template>
  <div class="footer">
      <div class="page-content-box content">
        <div class="links-box">
          <div class="links">
            <a href="https://www.pku.edu.cn" target="_blank">北京大学</a>
            <a href="https://www.icst.pku.edu.cn/" target="_blank">王选计算机研究所</a>
          </div>
          <div class="copyright">
            <span>&copy;Copyright 2023 纪念王选官网  All Rights Reserved.</span><span>京ICP备11032021号</span><span>京公网安备11010802018019号</span>
          </div>
        </div>
        <div class="qr-code">
          <el-image
          style="height: 100px"
          :src="require('@/assets/img/wict-weixin.png')"
          fit="contain"></el-image>
          <div class="wict-wx">北京大学王选计算机研究所官方微信</div>
        </div>
      </div>

  </div>
</template>

<script>
export default {
  props: {},
  data() {
    return {};
  },
  methods: {},
  created() {},
  mounted() {},
};
</script>

<style scoped>
.footer{
  width: 100%;  
  padding: 30px 30px;
  background: #014289;
  color: #fff;
  display: -webkit-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  flex-direction: column;
  align-items: center;
  box-sizing: border-box;
}

.footer .content{
  display: -webkit-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.links-box{
  display: -webkit-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  font-size: 16px;
  font-weight: normal;
  line-height: 17px;
  letter-spacing: 0em;
  
}

.links-box a{
  color: #FFFFFF;
  margin-right: 24px;
}
.links-box a:hover{
  color: #FFFFFF !important;
  opacity: 0.8 !important;
}
.links-box a:visited, .links-box a:active{
  color: #FFFFFF !important; 
}

.links-box .links{
  display: -webkit-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  flex-wrap: wrap;
}

.copyright{
  font-size: 12px;
  font-weight: normal;
  line-height: 17px;
  letter-spacing: 0em;
  color: rgb(244, 244, 245);
  display: -webkit-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  gap: 20px;
  flex-wrap: wrap;
  margin-top: 40px;
}

.qr-code{
  width: 120px;
  display: -webkit-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 10px;
  box-sizing: border-box;
}

.wict-wx{
  font-size: 12px;
  line-height: 20px;
  margin-top: 10px;
}
@media screen and (max-width: 650px) {
  .footer .content{
    display: -webkit-box;
    display: -ms-flexbox;
    display: -webkit-flex;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }

  .links-box .links{
    align-items: center;
    justify-content: center;
    margin-bottom: 20px;
  }
  .copyright{  
    display: -webkit-box;
    display: -ms-flexbox;
    display: -webkit-flex;
    display: flex;
    flex-direction: column;    
    gap: 5px;
    align-items: center;
    margin-top: 10px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/footer/index.vue